"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.endpoints = void 0;
exports.getInboxZeroBackground = getInboxZeroBackground;
exports.getQuoteOfTheDay = getQuoteOfTheDay;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _requests = require("@edison/requests");
var _functools = require("@edison/functools");
var _utils = require("./utils");
var _constants = require("../utils/constants");
var endpoints = exports.endpoints = {
  external: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/external");
    }
  }
};
/**
 * Return a list of mails by specified label and page
 *
 * @param {Auth} auth - User authentication info
 * @returns {Promise<QuoteOfTheDayResponse>}
 * @throws {RequestError}
 */
function getQuoteOfTheDay(_x) {
  return _getQuoteOfTheDay.apply(this, arguments);
}
function _getQuoteOfTheDay() {
  _getQuoteOfTheDay = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var auth, optionals, _endpoints$external, method, url, res;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          auth = _ref.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
            category: 'inspire',
            type: 'quote'
          }))(_utils.defaultOptionals);
          _endpoints$external = endpoints.external, method = _endpoints$external.method, url = _endpoints$external.url;
          _context.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context.sent;
          return _context.abrupt("return", res);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getQuoteOfTheDay.apply(this, arguments);
}
/**
 * Return a list of mails by specified label and page
 *
 * @param {Auth} auth - User authentication info
 * @returns {Promise<InboxZeroBackgroundRequest>}
 * @throws {RequestError}
 */
function getInboxZeroBackground(_x2) {
  return _getInboxZeroBackground.apply(this, arguments);
}
function _getInboxZeroBackground() {
  _getInboxZeroBackground = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2) {
    var auth, optionals, _endpoints$external2, method, url, res;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          auth = _ref2.auth;
          optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
            collections: '1d5pF-SZtak',
            type: 'image',
            client_id: 'oDHZW14Sg8T8r89vAjNIFwIlc8MUIQfWuKkeHbW63Pc'
          }))(_utils.defaultOptionals);
          _endpoints$external2 = endpoints.external, method = _endpoints$external2.method, url = _endpoints$external2.url;
          _context2.next = 5;
          return (0, _requests.request)(url(), method, optionals);
        case 5:
          res = _context2.sent;
          return _context2.abrupt("return", res);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getInboxZeroBackground.apply(this, arguments);
}
//# sourceMappingURL=external.js.map